<template>
    <div>
        <sticky :className="'sub-navbar draft'">
            <el-button v-loading="saveLoading" type="primary" @click="save">保存</el-button>
        </sticky>

        <div style="padding: 10px;">
            <el-card class="box-card" style="width: 50%;">
                <div slot="header" class="clearfix">
                    <span>角色明细</span>
                </div>
                <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
                    <el-form-item label="名称" prop="name">
                        <el-input style="width: 300px" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="角色类型" prop="roleType">
                        <el-select style="width: 200px" class="filter-item" v-model="form.roleType">
                            <el-option v-for="[value, label] in roleTypeAddMap" :key="value" :label="label" :value="value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="人管角色" :prop="!isBackendRole ? 'rgRole' : ''" v-if="!isBackendRole">
                        <el-select style="width: 200px" class="filter-item" v-model="form.rgRole" multiple>
                            <el-option v-for="item in rgList" :key="item.id" :label="item.roleName" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" style="width: 300px" v-model="form.remark"></el-input>
                    </el-form-item>
                </el-form>
            </el-card>
            <el-row style="margin-top:20px;">
                <el-col :span="8" style="padding-right: 10px;">
                    <el-card class="box-card" v-if="isBackendRole">
                        <div slot="header" class="clearfix">
                            <span>运营管理平台</span>
                        </div>
                        <el-tree ref="tree1" key="tree1" :data="list1" :props="defaultProps" show-checkbox check-strictly expand-on-click-node></el-tree>
                    </el-card>
                    <el-card class="box-card" v-else>
                        <div slot="header" class="clearfix">
                            <span>经销商系统</span>
                        </div>
                        <el-tree ref="tree2" key="tree2" :data="modules" :props="modulesProps" show-checkbox expand-on-click-node></el-tree>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <!-- <el-card class="box-card" style="padding-right: 10px;">
                        <div slot="header" class="clearfix">
                            <span>线索聚合平台</span>
                        </div>
                        <el-tree ref="tree2" :data="list2" :props="defaultProps" show-checkbox check-strictly expand-on-click-node></el-tree>
                    </el-card> -->
                </el-col>
            </el-row>

        </div>
    </div>
</template>

<script>
import Sticky from '@/components/Sticky' // 粘性header组件
import { roleTypeAddMap } from "./constants.js"
export default {
  name: 'SystemRoleAdd',
  components: {
    Sticky
  },
  data() {
    return {
      roleTypeAddMap,
      saveLoading: false,
      form: {
        name: '',
        remark: '',
        roleType: 1,
        rgRole: []
      },
      list1: [],
      list2: [],
      defaultProps: {
        children: 'subs',
        label: 'name'
      },
      modulesProps: {
        children: 'nodes',
        label: 'name'
      },
      formRules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度应在1-50位',
          trigger: 'blur'
        }],
        roleType: [{
            required: true,
            message: '请选择角色类型',
            trigger: 'blur'
        }],
        rgRole: [{
            required: true,
            message: '请选择人管角色',
            trigger: 'blur'
        }],
      },
      rgList: [], // 人管角色
      modules: [], // 店端菜单
    }
  },
  computed: {
    // 是否厂端角色
    isBackendRole() {
      return this.form.roleType === 1
    }
  },
  created() {
    this.getSysFunctions('PT1')
    this.getSysFunctions('PT2')
    this.getRgList()
    this.retrieveSystemData()
  },
  methods: {
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const { name, roleType, rgRole, remark } = this.form;
          const role = {}
          if(this.isBackendRole) {
            const checkedNodes1 = this.$refs.tree1.getCheckedNodes()
            role.PT1 = []
            for (const i of checkedNodes1) {
              role.PT1.push(i.id)
            }
          } else {
            const checkedNodes2 = this.$refs.tree2.getCheckedNodes()
            role.PT2 = []
            for (const i of checkedNodes2) {
              role.PT2.push(i.id)
            }
          }
          this.saveLoading = true
          this.$httpAuth
            .post('/v1/backendRoleRpc/add', {
              name,
              roleType, 
              rgRole: this.isBackendRole ? '' : rgRole.toString(),
              remark,
              role: JSON.stringify(role)
            })
            .then((response)=> {
              this.saveLoading = false
              this.$alert('保存成功', '添加角色', {
                confirmButtonText: '关闭',
                callback: action => {
                  this.$store.dispatch('delCurrentView')
                  this.$router.push('/system/role/list')
                }
              })
            })
            .catch(() => {
              this.saveLoading = false
            })
        }
      })
    },
    getSysFunctions(sys) {
      var parent = this
      this.$httpAuth
        .post('/v1/backendFunctionRpc/list', {
          pageStart: 0,
          pageCount: 1000,
          sys: sys,
          status: 0,
          key: ''
        })
        .then(function(response) {
          if (sys == 'PT1') {
            parent.list1 = response.data.data
          }
          if (sys == 'PT2') {
            parent.list2 = response.data.data
          }
        })
        .catch(() => {
          parent.listLoading = false
        })
    },
    getRgList() {
      this.$httpAuth
        .post('/v1/backendRoleRpc/rgList')
        .then((response) => {
          this.rgList = response.data.data
        })
        .catch(() => {
        })
    },
    retrieveSystemData() {
      this.$httpAuth.post("/v1/baseRpc/info", {}).then((res) => {
        const { modules = [] } = res.data;
        this.modules = modules.filter(
          (item) =>
            !["智蛛锐见", "签到", "库存", "即客", "企业微信"].includes(
              item.name
            )
        );
      });
    },
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
      console.log(this.$refs.tree1.getCheckedNodes())
    }
  }
}
</script>

<style>

</style>
